export const BANK_OPTIONS = [
  {
    text: "Duke-Elder Question Bank",
    value: "duke-elder-question-bank",
    soon: false,
  },
  {
    text: "Part 1 Question Bank",
    value: "part-1-question-bank",
    soon: false,
  },
  {
    text: "Part 2 Written Question Bank",
    value: "part-2-question-bank",
    soon: false,
  },
  {
    text: "Part 2 Oral Question Bank",
    value: "part-2-video-bank",
    soon: false,
  },
  {
    text: "ST1 Interview Bank",
    value: "interview-bank",
    soon: false,
  },
];

export const BANK_LABEL_BY_ID = BANK_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option.text;
  return acc;
}, {});

export const BANK_IDS = BANK_OPTIONS.map((option) => option.value);

export const ANNOUNCEMENT_TARGET_OPTIONS = [
  ...BANK_OPTIONS,
  {
    text: "ST1 AI Portfolio",
    value: "st1-portfolio",
    soon: false,
  },
  {
    text: "Pub2",
    value: "pub2",
    soon: false,
  },
];

export const ANNOUNCEMENT_TARGET_LABEL_BY_ID =
  ANNOUNCEMENT_TARGET_OPTIONS.reduce((acc, option) => {
    acc[option.value] = option.text;
    return acc;
  }, {});
